<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <BandejaComponente
        :aplica-busqueda-fecha="true"
      :icono="icono"
      :titulo="titulo"
      :codigoTitulo="codigoTitulo"
      :subTitulo="subTitulo"
      :cifrasControl="cifrasControl"
      :datosTabla="datosTabla"
      :resource="resource"
      @_funcionExtra="getObtenerDatosBandeja"
      @_actualizaFecha="actualizarFecha"
    ></BandejaComponente>
  </div>
</template>

<script>
import BandejaComponente from "../components/bandejas/BandejaComponente.vue";
import Swal from "sweetalert2";

export default {
  name: "BandejaCoordinadorEspecialidadReplicaRechazada",
  components: {
    BandejaComponente,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    idEmpleado: null,
    idClinica: null,
    idUsuario: null,
    idPaciente: 0,
    datosTabla: [],
    encabezadosPendientes: [
      {
        key: "pacientePresencial",
        label: "Paciente en Clínica",
        sortable: true,
        component: "PacientePresencialComponente",
      },
      {
        key: "dtefechaAlta",
        label: "Fecha",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacienteReplicaCEComponente",
      },
      {
        key: "nombreEmpleadoEspecialista",
        label: "Doctor especialista Solicitante",
        sortable: true,
      },
      {
        key: "nombreEmpleadoDiagnosticador",
        label: "Diagnosticador",
        sortable: true, 
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreEmpleadoDiagnosticador",
        label: "Diagnosticador",
        sortable: true, 
      }
    ],
    encabezadosEnProceso: [
      {
        key: "pacientePresencial",
        label: "Paciente en Clínica",
        sortable: true,
        component: "PacientePresencialComponente",
      },
      {
        key: "dtefechaAlta",
        label: "Fecha",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacienteReplicaCEComponente",
      },
      {
        key: "nombreEmpleadoEspecialista",
        label: "Doctor especialista Solicitante",
        sortable: true,
      },
      {
        key: "nombreEmpleadoDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreEmpleadoDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      }
    ],
    encabezadosFinalizados: [
      {
        key: "pacientePresencial",
        label: "Paciente en Clínica",
        sortable: true,
        component: "PacientePresencialComponente",
      },
      {
        key: "dtefechaAlta",
        label: "Fecha",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "LinkPacientePerfilBandejaEspecialidadComponente",
      },
      {
        key: "nombreEmpleadoEspecialista",
        label: "Doctor especialista Solicitante",
        sortable: true,
      },
      {
        key: "nombreEmpleadoDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreEmpleadoDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "dtefechaModificacion",
        label: "Fecha de salida de la réplica",
        component: "BandejaFechaTextoComponente",
      },
    ],

    cifrasControl: [
      {
        id: 1,
        nombre: "Pendientes",
        cantidad: 0,
        icono: "star",
        layoutTabla: [],
      },
      {
        id: 2,
        nombre: "En proceso",
        cantidad: 0,
        icono: "star-half",
        layoutTabla: [],
      },
      {
        id: 3,
        nombre: "Finalizados",
        cantidad: 0,
        icono: "star-fill",
        layoutTabla: [],
      },
    ],

    icono: "fa fa-credit-card",
    titulo: "COORDINADOR ESPECIALIDAD",
    codigoTitulo: "BJ_01_Rech_CE",
    subTitulo: "Bandeja CE Replica Rechazada",
    resource: { 
      idEstatusSolicitud: null, 
    },
    idEstatusPestañaSeleccionada : 1,
  }),
  methods: {
    getObtenerDatosBandeja(intIdEstuatusSolicitud) {
      this.showAlert();
      this.datosTabla = [];
      this.idEstatusPestañaSeleccionada = intIdEstuatusSolicitud;
 
      /*this.$http
        .get(
          this.$api +
            "replicas/bandeja/coordinadoresespecialidad/obtenerDatosBandejaCEReplicasRechazadas?fechaFinal=" +
            this.fechaFin +
            "&fechaIncio=" +
            this.fechaInicio +
            "&idEmpleado=" +
            this.idEmpleado +
            "&intIdEstuatusSolicitud=" +
            intIdEstuatusSolicitud +
            "&idPaciente=" +
            this.idPaciente
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray 
          this.resource.idEstatusSolicitud = intIdEstuatusSolicitud;
          this.datosTabla = response.data.data;
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        }).finally(() => {
          this.getCifrasPorEstatus();
        });*/
    },
    getCifrasPorEstatus() {
      this.showAlert();
      /*this.$http
        .get(
          this.$api +
            "replicas/bandeja/coordinadoresespecialidad/cifrasPorEstatusBandejaCEReplicasRechazadas?fechaFinal=" +
            this.fechaFin +
            "&fechaIncio=" +
            this.fechaInicio +
            "&idEmpleado=" +
            this.idEmpleado +
            "&idPaciente=" +
            this.idPaciente
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            var data = response.data.data;

            data.forEach((elemento) => {
              if (elemento.idEstatusSolicitud == 1) {
                this.cifrasControl[0].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[0].layoutTabla = this.encabezadosPendientes;
              }
              if (elemento.idEstatusSolicitud == 2) {
                this.cifrasControl[1].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[1].layoutTabla = this.encabezadosPendientes;
              }
              if (elemento.idEstatusSolicitud == 3) {
                this.cifrasControl[2].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[2].layoutTabla = this.encabezadosFinalizados;
              }
            });
          Swal.close();
          }
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        });*/
    }, //  ----------------------------
 
    actualizarFecha(fechaInicio, fechaFin, idPaciente) {
      if (fechaFin !== null && fechaInicio !== null){
        this.fechaInicio = fechaInicio;
        this.fechaFin = fechaFin;
      }
      this.idPaciente = idPaciente === null ? 0 : idPaciente;
      this.getObtenerDatosBandeja(this.idEstatusPestañaSeleccionada);
    },

    showAlert() {
      Swal.fire({
        title: "Se esta cargando la pagina.",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },

  },
  mounted() {
    this.getObtenerDatosBandeja(1);
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.resource = { 
      idEstatusSolicitud: null, 
    };
    this.ruta = this.$route.params.ruta;
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();
    var dia1 = new Date();
    dia1.setDate(dia1.getDate() - 3);
    dia1.setHours(0, 0, 0, 0);
    this.fechaInicio = this.$moment(dia1)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    var dia2 = new Date();
    dia2.setHours(23, 60, 59, 999);
    this.fechaFin = this.$moment(dia2)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
  },
  computed: {},
};
</script>
